import React from "react";
import BankRateLineChart from "./BankRateLineChart";

class TreasuryBillsLineChart extends React.Component {

    constructor(props) {
        super(props);
        this.chartReference = React.createRef();
        this.state = {
          initialLoad: true,
          chartDataSet1: [],
          chartDataSet2: []
        }
    }

    componentDidMount() {
      if (this.props.dataIsReady) {
        this.processData();
      }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.data && this.state.initialLoad) {
        this.processData();
      }
    }

    processData = () => {
      let billRates = this.props.data.billRates;
      let getBillRatesWithDuration = (duration) => billRates.filter(item => item.term === duration);
      let selectedDurationRates = getBillRatesWithDuration(this.props.duration).reverse();
      this.setState({
        initialLoad: false,
        chartDataSet1: selectedDurationRates.map(item => {
          return {
            data: item.highDiscountRate,
            label: new Date(item.issueDate).toLocaleDateString("en-US", {year: '2-digit', month: 'numeric', day: 'numeric'})
          }}),
        chartDataSet2: selectedDurationRates.map(item => {return {data: item.lowDiscountRate}})
      });
    };

    render() {
      return (
        <BankRateLineChart
          dataReady={!this.state.initialLoad}
          data={{chartDataSet1: this.state.chartDataSet1, chartDataSet2: this.state.chartDataSet2}}
          title={this.props.title}
        />
      );
    }
}

export default TreasuryBillsLineChart;